import * as a from "react";
const e = (l) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M13.13 4.135a.381.381 0 00-.532 0l-8.534 8.546a.376.376 0 000 .532l3.201 3.205a.36.36 0 00.524 0l8.542-8.546a.382.382 0 000-.531l-3.202-3.206zM3.264 14.022a.382.382 0 00-.52-.01.36.36 0 00-.1.16L1.02 18.981a.367.367 0 00.09.382.374.374 0 00.404.12l4.802-1.603a.39.39 0 00.247-.27.368.368 0 00-.105-.375l-3.194-3.213zM18.223 2.256a2.69 2.69 0 00-3.74 0l-.53.532a.374.374 0 000 .532l3.2 3.205a.381.381 0 00.524 0l.546-.524a2.643 2.643 0 000-3.745z",
      fill: "#2d6ded"
    }
  )
);
export {
  e as default
};
